/*
 * ZaunScout Produktkonfigurator
 *
 * Liest die Schritte (Theme-Blöcke) aus dem Abschnitt "ZS Konfigurator" und steuert:
 * - Auswahl der Varianten (Optionen, Produktwechsel zwischen Geschwisterprodukten)
 * - Lagerbestand inkl. "Weiterverkaufen, wenn ausverkauft" pro Variante
 * - Bild der gewählten Variante und Galerie
 * - Zusatzprodukte, Auswahl ohne Preis, Bedingungen
 * - Warenkorb: alle Positionen in einem Aufruf, verbunden über _konfig_id
 */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('zs-konfigurator')) return;

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DEFAULT_TITLE = 'Default Title';

  /* ---------- Hilfsfunktionen ---------- */

  function norm(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  // Wörter für den Bild-Abgleich über Alt-Texte: " anthrazit 180 cm "
  function words(value) {
    return ' ' + norm(value).replace(/[^a-z0-9äöüß]+/g, ' ').trim() + ' ';
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('[ZS Konfigurator] Daten konnten nicht gelesen werden', error);
      return null;
    }
  }

  function splitList(text, separator) {
    return String(text || '')
      .split(separator)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount_with_comma_separator}} €';

    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var match = fmt.match(placeholder);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- Produkt-Logik ---------- */

  function optionIndex(product, name) {
    var key = norm(name);
    for (var i = 0; i < product.options.length; i++) {
      if (norm(product.options[i]) === key) return i;
    }
    return -1;
  }

  function hasOnlyDefaultVariant(product) {
    return product.variants.length === 1 && product.variants[0].title === DEFAULT_TITLE;
  }

  function uniqueValues(product, index) {
    var seen = [];
    product.variants.forEach(function (variant) {
      var value = variant.options[index];
      if (seen.indexOf(value) === -1) seen.push(value);
    });
    return seen;
  }

  // Auswahl ist ein Objekt { "breite": "300 cm", ... } mit normalisierten Optionsnamen als Schlüssel
  function findExact(product, selection) {
    for (var v = 0; v < product.variants.length; v++) {
      var variant = product.variants[v];
      var ok = true;
      for (var i = 0; i < product.options.length; i++) {
        if (selection[norm(product.options[i])] !== variant.options[i]) { ok = false; break; }
      }
      if (ok) return variant;
    }
    return null;
  }

  // Beste Variante: lieferbar vor ausverkauft, dann möglichst viele gleiche Werte (frühe Optionen zählen mehr)
  function bestVariant(product, selection, fixedKey) {
    var best = null;
    var bestScore = -1;
    var count = product.options.length;
    product.variants.forEach(function (variant) {
      var score = 0;
      for (var i = 0; i < count; i++) {
        var key = norm(product.options[i]);
        if (key === fixedKey) {
          if (variant.options[i] !== selection[key]) return;
          continue;
        }
        if (selection[key] === variant.options[i]) score += count - i;
      }
      if (variant.available) score += 1000;
      if (score > bestScore) {
        best = variant;
        bestScore = score;
      }
    });
    return best;
  }

  function sameOptions(a, b) {
    if (a.options.length !== b.options.length) return false;
    return a.options.every(function (name) { return optionIndex(b, name) !== -1; });
  }

  /* ---------- Konfigurator ---------- */

  class ZsKonfigurator extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;

      var data = readJSON(this.querySelector('script[data-zs-main]'));
      if (!data || !data.product) return;

      this.settings = data.settings || {};
      this.mainProduct = data.product;
      this.product = data.product;
      this.selection = {};
      this.qty = 1;
      this.auswahl = {};
      this.zusatz = {};
      this.cartQty = {};
      this.galleryPick = null;
      this.triedToAdd = false;

      this.moveBottomBlocks();
      this.collectSteps();
      this.initSelection(data.initialVariant);
      this.bindEvents();
      this.render();
      this.watchAddButton();
      this.loadCart();
      this.preloadImages();
      if (DESIGN_MODE) this.watchEditor();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._barCheck) {
        window.removeEventListener('scroll', this._barCheck);
        window.removeEventListener('resize', this._barCheck);
      }
    }

    // Blöcke mit Stil „Downloads“ stehen unter der Kaufbox statt zwischen den Schritten
    moveBottomBlocks() {
      var slot = this.querySelector('[data-zs-unten-slot]');
      if (!slot) return;
      this.querySelectorAll('.zs-konfig__steps [data-zs-unten]').forEach(function (el) { slot.appendChild(el); });

      // Alle Links (Text-Block „Downloads“ und übernommener Liquid-Code) als eine Zeile „Downloads“
      // mit Symbol: Dokument für PDFs, Play für Videos. Gleiche Optik wie im Zaunkonfigurator.
      var links = Array.prototype.slice.call(slot.querySelectorAll('a[href]'));
      if (!links.length) return;
      var gesehen = {};
      var html = '';
      links.forEach(function (link) {
        var href = link.getAttribute('href');
        if (gesehen[href]) return;
        gesehen[href] = true;
        var text = link.textContent.replace(/\s+/g, ' ').trim() || 'Download';
        var video = /\.(mp4|mov|webm)(\?|$)/i.test(href) || /youtu|vimeo/i.test(href) || /video/i.test(text);
        var icon = video
          ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M10 8.5v7l5.5-3.5z"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4M10 12h5M10 15.5h5"/></svg>';
        if (video && /^Montageanleitung als Video$/i.test(text)) text = 'Montagevideo';
        html += '<li><a href="' + esc(href) + '" target="_blank" rel="noopener">' + icon + '<span>' + esc(text) + '</span></a></li>';
      });
      // Originale ausblenden (per Klasse, das Rendern der Schritte setzt hidden bei jeder Änderung neu)
      Array.prototype.forEach.call(slot.children, function (el) {
        if (el.querySelector('a[href]')) el.classList.add('zs-unten--ersetzt');
      });
      var box = document.createElement('div');
      box.className = 'zs-downloads';
      box.innerHTML = '<p class="zs-downloads__title">Downloads</p><ul class="zs-downloads__list">' + html + '</ul>';
      slot.appendChild(box);
    }

    // Schwebender Button erscheint erst, wenn der Hauptbutton nach oben aus dem Bild gescrollt ist.
    // Scroll-Prüfung statt IntersectionObserver: der meldet nichts, wenn man in einem Sprung darüber scrollt.
    watchAddButton() {
      var bar = this.querySelector('[data-zs-bar]');
      var main = this.querySelector('[data-zs-add]');
      if (!bar || !main) return;
      var queued = false;
      var shown = null;
      var check = function () {
        queued = false;
        var show = main.getBoundingClientRect().bottom < 0;
        if (show === shown) return;
        shown = show;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelectorAll('button').forEach(function (button) { button.tabIndex = show ? 0 : -1; });
      };
      this._barCheck = function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(check);
      };
      window.addEventListener('scroll', this._barCheck, { passive: true });
      window.addEventListener('resize', this._barCheck, { passive: true });
      check();
    }

    money(cents) {
      return formatMoney(cents, this.settings.moneyFormat);
    }

    /* ----- Schritte einlesen ----- */

    collectSteps() {
      var self = this;
      this.steps = [];

      this.querySelectorAll('[data-zs-step]').forEach(function (el, index) {
        var config = readJSON(el.querySelector(':scope > script[data-zs-config]'));
        if (!config) return;

        var step = Object.assign({}, config, {
          el: el,
          body: el.querySelector(':scope > [data-zs-body]'),
          current: el.querySelector(':scope > .zs-step__head [data-zs-current]'),
          key: config.id || 'step-' + index,
          condStep: norm(config.cond && config.cond.step),
          condValues: splitList(config.cond && config.cond.values, ',').map(norm)
        });

        if (step.type === 'option') {
          step.werte = {};
          el.querySelectorAll(':scope > .zs-step__children [data-zs-wert]').forEach(function (node) {
            step.werte[norm(node.dataset.value)] = {
              img: node.dataset.img || '',
              label: node.dataset.label || '',
              desc: node.dataset.desc || '',
              badge: node.dataset.badge || ''
            };
          });
        }

        if (step.type === 'familie') {
          step.members = [];
          el.querySelectorAll(':scope > .zs-step__children script[data-zs-member]').forEach(function (node) {
            var member = readJSON(node);
            if (member) step.members.push(member);
          });
          step.values = [];
          step.members.forEach(function (member) {
            if (member.product && step.values.indexOf(member.value) === -1) step.values.push(member.value);
          });
        }

        if (step.type === 'zusatz' && !self.zusatz[step.key]) {
          var preselected = step.mode !== 'optional';
          self.zusatz[step.key] = {
            on: preselected,
            qty: step.display === 'menge' ? (preselected ? 1 : 0) : 1,
            variantId: null
          };
        }

        if (step.type === 'auswahl') {
          // Zeile „Name | #Farbcode | Bild-URL“: Farbcode und Bild sind optional (für Farbfelder)
          step.farben = {};
          step.bilder = {};
          step.hinweise = {};
          step.values = splitList(step.werte, /\r?\n/).map(function (zeile) {
            var teile = zeile.split('|').map(function (t) { return t.trim(); });
            if (teile[1] && /^(#|rgb|hsl|linear-gradient)/i.test(teile[1])) step.farben[teile[0]] = teile[1];
            else if (teile[1]) step.hinweise[teile[0]] = teile[1];
            if (teile[2]) step.bilder[teile[0]] = teile[2];
            return teile[0];
          });
          if (!(step.key in self.auswahl)) self.auswahl[step.key] = step.standard || '';
        }

        el.setAttribute('data-zs-ready', '');
        self.steps.push(step);
      });

      // Produktwechsel: auch mehrere Schritte (z. B. Pfostentyp und Farbe). Jedes Produkt hat je Schritt einen Wert.
      this.familySteps = this.steps.filter(function (step) { return step.type === 'familie'; });
      this.familyStep = this.familySteps[0] || null;
      if (this.familySteps.length === 1) {
        var only = this.familyStep;
        var hasMain = only.members.some(function (member) { return member.product && member.product.id === self.mainProduct.id; });
        if (!hasMain) {
          only.members.unshift({ value: self.mainProduct.title, img: null, product: self.mainProduct, implicit: true });
          only.values.unshift(self.mainProduct.title);
        }
      }
    }

    allProducts() {
      var list = [this.mainProduct];
      (this.familySteps || []).forEach(function (step) {
        step.members.forEach(function (member) {
          if (member.product && !list.some(function (p) { return p.id === member.product.id; })) {
            list.push(member.product);
          }
        });
      });
      return list;
    }

    /* ----- Startauswahl ----- */

    initSelection(initialVariantId) {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = Number(params.get('variant')) || null;
      // Gemerkte Auswahl vom Produktwechsel (z. B. von „2 m hoch“), höchstens 5 Minuten alt
      try {
        var gemerkt = JSON.parse(window.sessionStorage.getItem('zs-wechsel') || 'null');
        if (gemerkt) {
          window.sessionStorage.removeItem('zs-wechsel');
          var pfad = window.location.pathname.replace(/\/$/, '');
          if (!fromUrl && Date.now() - gemerkt.zeit < 300000 && pfad.slice(-gemerkt.pfad.length) === gemerkt.pfad) {
            fromUrl = Number(gemerkt.variante) || null;
          }
        }
      } catch (e) { /* Speicher nicht verfügbar */ }
      var found = this.findVariantAnywhere(fromUrl || initialVariantId);

      if (found) {
        this.product = found.product;
        this.applyVariant(found.variant);
      }

      var current = this.currentVariant();
      if (!current || (!current.available && !fromUrl)) {
        var best = bestVariant(this.product, this.selection, null);
        if (best) this.applyVariant(best);
      }
    }

    findVariantAnywhere(id) {
      if (!id) return null;
      var products = this.allProducts();
      for (var p = 0; p < products.length; p++) {
        for (var v = 0; v < products[p].variants.length; v++) {
          if (products[p].variants[v].id === id) return { product: products[p], variant: products[p].variants[v] };
        }
      }
      return null;
    }

    applyVariant(variant) {
      var self = this;
      this.product.options.forEach(function (name, i) {
        self.selection[norm(name)] = variant.options[i];
      });
    }

    currentVariant() {
      return findExact(this.product, this.selection);
    }

    /* ----- Bestand ----- */

    maxQty(variant) {
      if (!variant || !variant.available) return 0;
      var inCart = this.cartQty[variant.id] || 0;
      if (variant.managed && variant.policy === 'deny') return Math.max(0, variant.qty - inCart);
      return 9999;
    }

    mainMaxQty() {
      return Math.min(Number(this.settings.maxQty) || 99, this.maxQty(this.currentVariant()));
    }

    stockInfo(variant) {
      var s = this.settings;
      if (!variant) return { level: 'out', text: 'Diese Kombination gibt es nicht' };
      if (!variant.available) return { level: 'out', text: s.textAusverkauft };
      // Fester Liefertermin (Metafeld), z. B. Vorbestellung „ab Ende November“
      if (s.lieferhinweis) return { level: 'low', text: 'Jetzt vorbestellen, lieferbar ' + s.lieferhinweis, hinweis: true };
      var left = variant.qty - (this.cartQty[variant.id] || 0);
      if (variant.managed && variant.policy === 'deny') {
        if (left <= 0) return { level: 'out', text: 'Der verfügbare Bestand liegt schon im Warenkorb' };
        if (left <= (Number(s.lowStock) || 0)) return { level: 'low', text: String(s.textWenig || '').replace('[anzahl]', left) };
        return { level: 'ok', text: s.textLieferbar };
      }
      if (variant.managed && left <= 0) return { level: 'low', text: s.textNachbestellt, nachbestellt: true };
      return { level: 'ok', text: s.textLieferbar };
    }

    valueStatus(key, value) {
      var test = Object.assign({}, this.selection);
      test[key] = value;
      var variant = findExact(this.product, test);
      if (variant) return variant.available ? 'ok' : 'soldout';
      var index = optionIndex(this.product, key);
      var other = this.product.variants.some(function (v) { return v.options[index] === value && v.available; });
      return other ? 'missing' : 'soldout';
    }

    variantForValue(key, value) {
      var test = Object.assign({}, this.selection);
      test[key] = value;
      return findExact(this.product, test) || bestVariant(this.product, test, key);
    }

    memberStatus(member) {
      if (!member.product) return 'missing';
      var variant = findExact(member.product, this.selection);
      if (variant) return variant.available ? 'ok' : 'soldout';
      return member.product.variants.some(function (v) { return v.available; }) ? 'missing' : 'soldout';
    }

    /* ----- Zusatzprodukte ----- */

    addonVariant(step) {
      var product = step.product;
      if (!product || !product.variants.length) return null;
      var state = this.zusatz[step.key];
      var self = this;

      if (step.variante === 'kunde') {
        var chosen = product.variants.filter(function (v) { return v.id === state.variantId; })[0];
        return chosen || product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      }

      if (step.variante === 'passend') {
        var matches = this.addonMatches(step);
        var picked = matches.filter(function (v) { return v.id === state.variantId; })[0];
        return picked || matches.filter(function (v) { return v.available; })[0] || matches[0] || null;
      }

      return product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    }

    // Varianten des Zusatzprodukts, die zur Auswahl passen: gleichnamige Option
    // oder (z. B. "Höhe" statt "Zaunhöhe") eine Option, in der der gewählte Wert vorkommt
    addonMatches(step) {
      var product = step.product;
      var self = this;
      var chosen = Object.keys(this.selection).map(function (key) { return self.selection[key]; });
      var constraints = product.options.map(function (name, i) {
        var key = norm(name);
        if (key in self.selection) return self.selection[key];
        var values = uniqueValues(product, i);
        for (var c = 0; c < chosen.length; c++) {
          if (values.indexOf(chosen[c]) !== -1) return chosen[c];
        }
        return null;
      });
      return product.variants.filter(function (variant) {
        return constraints.every(function (value, i) { return value === null || variant.options[i] === value; });
      });
    }

    addonQty(step) {
      var state = this.zusatz[step.key];
      if (step.display === 'menge') return state.qty;
      var base = Math.max(1, Number(step.mengePro) || 1);
      return step.gekoppelt ? base * this.qty : base;
    }

    addonActive(step) {
      if (step.type !== 'zusatz' || !step.product || !this.isVisible(step)) return false;
      var state = this.zusatz[step.key];
      if (step.display === 'menge') return state.qty > 0;
      return step.mode === 'pflicht' || state.on;
    }

    addonMax(step) {
      var variant = this.addonVariant(step);
      var max = this.maxQty(variant);
      if (step.display === 'menge') max = Math.min(max, Number(step.maxMenge) || 10);
      return max;
    }

    /* ----- Bedingungen ----- */

    stepValue(step) {
      if (step.type === 'option') return this.selection[norm(step.name)] || '';
      if (step.type === 'familie') {
        var member = this.activeMember(step);
        return member ? member.value : '';
      }
      if (step.type === 'auswahl') return this.auswahl[step.key] || '';
      if (step.type === 'zusatz') return this.addonActive(step) ? 'ja' : 'nein';
      return '';
    }

    valueByName(name, asking) {
      for (var i = 0; i < this.steps.length; i++) {
        var step = this.steps[i];
        if (step === asking) continue;
        if (norm(step.label) === name || (step.type === 'option' && norm(step.name) === name)) {
          return this.stepValue(step);
        }
      }
      return this.selection[name] || '';
    }

    isVisible(step) {
      if (!step.condStep) return true;
      var value = norm(this.valueByName(step.condStep, step));
      return step.condValues.indexOf(value) !== -1;
    }

    activeMember(step) {
      step = step || this.familyStep;
      if (!step) return null;
      var id = this.product.id;
      return step.members.filter(function (member) {
        return member.product && member.product.id === id;
      })[0] || null;
    }

    // Produkt für Wert „value“ im Schritt „step“, das in den übrigen Wechsel-Schritten möglichst die aktuellen Werte behält
    targetMember(step, value) {
      var self = this;
      var candidates = step.members.filter(function (member) { return member.product && member.value === value; });
      var best = null;
      var bestScore = -1;
      candidates.forEach(function (candidate) {
        var score = 0;
        self.familySteps.forEach(function (other) {
          if (other === step) return;
          var current = self.activeMember(other);
          if (!current) return;
          var match = other.members.some(function (m) {
            return m.product && m.product.id === candidate.product.id && m.value === current.value;
          });
          if (match) score++;
        });
        if (score > bestScore) { best = candidate; bestScore = score; }
      });
      return best;
    }

    /* ----- Aktionen ----- */

    selectOption(name, value) {
      var key = norm(name);
      // Eigenes Bild des gewählten Werts groß zeigen (Einstellung im Option-Block)
      var step = this.steps.filter(function (s) { return s.type === 'option' && norm(s.name) === key; })[0];
      // Seite für eine feste Höhe (z. B. 2 m hoch): andere Werte führen zum allgemeinen Produkt
      if (step && step.wechsel && step.wechsel.url) {
        var behalten = splitList(step.wechsel.behalten, ',').map(norm);
        if (behalten.length && behalten.indexOf(norm(value)) === -1) {
          this.wechselZu(step.wechsel, key, value);
          return;
        }
      }
      this.selection[key] = value;
      var extra = step && step.stageOnSelect && step.werte ? step.werte[norm(value)] : null;
      this.stageOverride = extra && extra.img ? { id: null, src: extra.img, alt: extra.label || value } : null;
      if (!this.currentVariant()) {
        var best = bestVariant(this.product, this.selection, key);
        if (best) this.applyVariant(best);
      }
      this.galleryPick = null;
      this.afterChange('option', name, value);
    }

    wechselZu(wechsel, key, value) {
      var self = this;
      // Gleiche Ausführung im Zielprodukt suchen: alle Optionen wie jetzt, nur der neue Wert
      var wunsch = this.product.options.map(function (name) {
        return norm(norm(name) === key ? value : self.selection[norm(name)] || '');
      });
      var varianten = wechsel.varianten || [];
      // Werte unabhängig von der Reihenfolge vergleichen (Optionen können im Zielprodukt anders sortiert sein)
      var treffer = varianten.filter(function (v) {
        var werte = v.options.map(norm);
        return wunsch.every(function (w) { return werte.indexOf(w) !== -1; });
      })[0] || varianten.filter(function (v) {
        return v.options.some(function (o) { return norm(o) === norm(value); });
      })[0];
      // Vorhandene Parameter (z. B. Theme-Vorschau) mitnehmen, Variante setzen
      var params = new URLSearchParams(window.location.search);
      params.delete('variant');
      if (treffer) params.set('variant', treffer.id);
      var query = params.toString();
      var url = wechsel.url.split('?')[0] + (query ? '?' + query : '');
      // Falls eine Weiterleitung den Parameter verliert: Auswahl zusätzlich kurz merken
      if (treffer) {
        try {
          window.sessionStorage.setItem('zs-wechsel', JSON.stringify({ pfad: new URL(wechsel.url, window.location.href).pathname.replace(/\/$/, ''), variante: treffer.id, zeit: Date.now() }));
        } catch (e) { /* Speicher nicht verfügbar */ }
      }
      this.classList.add('is-wechsel');
      window.location.href = url;
    }

    switchMember(stepKey, value) {
      var step = this.stepByKey(stepKey) || this.familyStep;
      if (!step) return;
      var member = this.targetMember(step, value);
      if (!member || !member.product) return;
      this.product = member.product;
      this.stageOverride = null;
      var variant = this.currentVariant();
      if (!variant) {
        variant = bestVariant(this.product, this.selection, null);
        if (variant) this.applyVariant(variant);
      }
      this.galleryPick = null;
      this.afterChange('produktwechsel', step.label, member.value);
    }

    setQty(value) {
      var max = Math.max(1, this.mainMaxQty());
      this.qty = clamp(Math.round(value) || 1, 1, max);
      this.render();
    }

    changeAddonQty(key, delta) {
      var step = this.stepByKey(key);
      if (!step) return;
      var min = step.mode === 'pflicht' ? 1 : 0;
      var state = this.zusatz[key];
      state.qty = clamp(state.qty + delta, min, Math.max(min, this.addonMax(step)));
      this.render();
    }

    stepLabel(key) {
      var step = this.stepByKey(key);
      return step ? step.label : key;
    }

    stepByKey(key) {
      return this.steps.filter(function (step) { return step.key === key; })[0] || null;
    }

    afterChange(kind, name, value) {
      this.qty = clamp(this.qty, 1, Math.max(1, this.mainMaxQty()));
      this.render();
      this.track('schritt', { art: kind, schritt: name, wert: value });
    }

    /* ----- Events ----- */

    bindEvents() {
      var self = this;

      this.addEventListener('click', function (event) {
        var target = event.target.closest('[data-zs-action]');
        if (!target || !self.contains(target)) return;
        var action = target.dataset.zsAction;
        var data = target.dataset;

        if (action === 'option') self.selectOption(data.zsName, data.zsValue);
        else if (action === 'member') self.switchMember(data.zsKey, data.zsValue);
        else if (action === 'auswahl') {
          self.auswahl[data.zsKey] = data.zsValue;
          self.afterChange('auswahl', self.stepLabel(data.zsKey), data.zsValue);
        } else if (action === 'zusatz-toggle') {
          var state = self.zusatz[data.zsKey];
          state.on = !state.on;
          self.afterChange('zusatz', self.stepLabel(data.zsKey), state.on ? 'ja' : 'nein');
        } else if (action === 'zusatz-qty') self.changeAddonQty(data.zsKey, Number(data.zsDelta));
        else if (action === 'qty') self.setQty(self.qty + Number(data.zsDelta));
        else if (action === 'thumb') {
          self.galleryPick = Number(data.zsMedia);
          self.stageOverride = null;
          self.renderGallery();
        } else if (action === 'add') self.addToCart();
        else if (action === 'help') {
          var stepEl = target.closest('.zs-step');
          var help = stepEl && stepEl.querySelector(':scope > .zs-step__help');
          if (help) self.openDialog(target.getAttribute('data-zs-title') || '', help.innerHTML);
        } else if (action === 'dialog-close') self.closeDialog();
        else if (action === 'mail') self.mailConfiguration(target);
        else if (action === 'versand-info') {
          var info = self.querySelector('template[data-zs-versand-info]');
          if (info) self.openDialog('Lieferung und Versand', info.innerHTML);
        }
      });

      this.addEventListener('click', function (event) {
        if (event.target.matches && event.target.matches('[data-zs-dialog]')) self.closeDialog();
      });

      this.addEventListener('change', function (event) {
        var target = event.target;
        var action = target.dataset && target.dataset.zsAction;
        if (!action) return;

        if (action === 'option-select') self.selectOption(target.dataset.zsName, target.value);
        else if (action === 'member-select') self.switchMember(target.dataset.zsKey, target.value);
        else if (action === 'auswahl-select') {
          self.auswahl[target.dataset.zsKey] = target.value;
          self.afterChange('auswahl', self.stepLabel(target.dataset.zsKey), target.value);
        } else if (action === 'zusatz-variant') {
          self.zusatz[target.dataset.zsKey].variantId = Number(target.value);
          self.render();
        } else if (action === 'qty-input') self.setQty(parseInt(target.value, 10));
      });

      this.addEventListener('input', function (event) {
        var target = event.target;
        if (target.dataset && target.dataset.zsAction === 'auswahl-text') {
          self.auswahl[target.dataset.zsKey] = target.value;
          self.applyVisibility();
          self.renderSummary();
        }
      });
    }

    openDialog(title, html) {
      var dialog = this.querySelector('[data-zs-dialog]');
      if (!dialog) return;
      dialog.querySelector('[data-zs-dialog-title]').textContent = title;
      dialog.querySelector('[data-zs-dialog-body]').innerHTML = html;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    closeDialog() {
      var dialog = this.querySelector('[data-zs-dialog]');
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    watchEditor() {
      var self = this;
      this._observer = new MutationObserver(function () {
        var stale = self.steps.some(function (step) { return !self.contains(step.el); });
        var fresh = self.querySelector('[data-zs-step]:not([data-zs-ready])');
        if (stale || fresh) {
          self.collectSteps();
          self.render();
        }
      });
      this._observer.observe(this, { childList: true, subtree: true });

      document.addEventListener('shopify:block:select', function (event) {
        if (self.contains(event.target)) {
          event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    /* ----- Darstellung ----- */

    render() {
      var focusKey = document.activeElement && this.contains(document.activeElement)
        ? document.activeElement.getAttribute('data-zs-focus')
        : null;

      this.renderAuto();
      this.renderSteps();
      this.applyVisibility();
      this.renderGallery();
      this.renderSummary();
      this.updateUrl();
      if (DESIGN_MODE) this.renderDesignInfo();

      if (focusKey) {
        var again = this.querySelector('[data-zs-focus="' + focusKey.replace(/"/g, '\\"') + '"]');
        if (again) again.focus();
      }
    }

    coveredOptions() {
      var covered = {};
      this.steps.forEach(function (step) {
        if (step.type === 'option') covered[norm(step.name)] = true;
      });
      return covered;
    }

    renderAuto() {
      var container = this.querySelector('[data-zs-auto]');
      if (!container) return;
      if (!this.settings.autoOptions || hasOnlyDefaultVariant(this.product)) {
        container.innerHTML = '';
        return;
      }
      var covered = this.coveredOptions();
      var self = this;

      // Automatische Optionen direkt hinter die letzte Option bzw. den Produktwechsel setzen
      var lastOption = null;
      this.steps.forEach(function (step) {
        if (step.type === 'option' || step.type === 'familie') lastOption = step;
      });
      if (lastOption && lastOption.el.nextElementSibling !== container) {
        lastOption.el.parentNode.insertBefore(container, lastOption.el.nextElementSibling);
      }

      container.innerHTML = this.product.options
        .filter(function (name, index) {
          // Optionen mit nur einem Wert (z. B. Farbe Anthrazit) gibt es nichts zu wählen
          return !covered[norm(name)] && uniqueValues(self.product, index).length > 1;
        })
        .map(function (name) {
          var step = { name: name, label: name, display: 'knoepfe', priceDiff: self.settings.autoPriceDiff };
          return '<div class="zs-step zs-step--option zs-step--auto">' +
            '<div class="zs-step__head"><span class="zs-step__num" aria-hidden="true"></span>' +
            '<span class="zs-step__label">' + esc(name) + '</span>' +
            '<span class="zs-step__value">' + esc(self.selection[norm(name)] || '') + '</span></div>' +
            '<div class="zs-step__body">' + self.optionBody(step) + '</div></div>';
        })
        .join('');
    }

    renderSteps() {
      var self = this;
      this.steps.forEach(function (step) {
        if (!step.body) return;
        var html = '';
        if (step.type === 'option') html = self.optionBody(step);
        else if (step.type === 'familie') html = self.familieBody(step);
        else if (step.type === 'auswahl') html = self.auswahlBody(step);
        else if (step.type === 'zusatz') html = self.zusatzBody(step);

        // Freitextfeld nicht neu zeichnen, sonst springt der Cursor
        if (step.type === 'auswahl' && step.display === 'text' && step.body.querySelector('input')) {
          // nichts
        } else {
          step.body.innerHTML = html;
        }

        if (step.current) {
          var value = step.type === 'zusatz' ? '' : self.stepValue(step);
          if (step.type === 'option' && step.werte && step.werte[norm(value)] && step.werte[norm(value)].label) {
            value = step.werte[norm(value)].label;
          }
          step.current.textContent = value;
        }
      });
    }

    applyVisibility() {
      var self = this;
      this.steps.forEach(function (step) {
        step.el.hidden = !self.isVisible(step) || (step.type === 'zusatz' && step.ausblenden);
      });
    }

    optionBody(step) {
      var self = this;
      var product = this.product;
      var index = optionIndex(product, step.name);

      if (index === -1) {
        if (!DESIGN_MODE) return '';
        return warn('Die Option „' + esc(step.name || '(leer)') + '“ gibt es bei diesem Produkt nicht. Vorhanden: ' +
          esc(product.options.join(', ')) + '.');
      }

      var key = norm(product.options[index]);
      var values = uniqueValues(product, index);
      var current = this.selection[key];
      var currentVariant = this.currentVariant();
      var werte = step.werte || {};

      function soldoutLabel(status) {
        if (status === 'soldout') return self.settings.textAusverkauft;
        if (status === 'missing') return 'nicht in dieser Kombination';
        return '';
      }

      function diffFor(value) {
        if (!step.priceDiff || value === current || !currentVariant) return '';
        var variant = self.variantForValue(key, value);
        if (!variant || variant.price === currentVariant.price) return '';
        var diff = variant.price - currentVariant.price;
        return (diff > 0 ? '+ ' : '− ') + self.money(Math.abs(diff));
      }

      if (step.display === 'dropdown') {
        return '<div class="zs-select"><select data-zs-action="option-select" data-zs-name="' + esc(step.name) +
          '" data-zs-focus="sel:' + esc(key) + '" aria-label="' + esc(step.label || step.name) + '">' +
          values.map(function (value) {
            var status = self.valueStatus(key, value);
            var note = soldoutLabel(status);
            var label = (werte[norm(value)] || {}).label || value;
            return '<option value="' + esc(value) + '"' + (value === current ? ' selected' : '') + '>' +
              esc(label) + (note ? ' (' + esc(note) + ')' : '') + '</option>';
          }).join('') + '</select></div>';
      }

      var look = lookFor(step.display);
      var tiles = look !== 'btn';
      var labels = values.map(function (value) { return (werte[norm(value)] || {}).label || value; });
      var html = '<div class="' + containerClass(look) + '"' + gridStyle(look, labels) + ' role="radiogroup" aria-label="' + esc(step.label || step.name) + '">';

      // Variante ohne eigenes Bild (z. B. Sichtschutzrolle Anthrazit): Hauptbild des Produkts,
      // aber nur wenn keine andere Kachel dieser Option es schon zeigt
      var genutzt = {};
      if (tiles) {
        values.forEach(function (value) {
          var v = self.variantForValue(key, value);
          var bild = (werte[norm(value)] || {}).img || (v && v.image_src);
          if (bild) genutzt[bild.split('?')[0]] = true;
        });
      }
      var ersatzbild = tiles && self.product.image && !genutzt[self.product.image.split('?')[0]] ? self.product.image : '';

      values.forEach(function (value) {
        var status = self.valueStatus(key, value);
        var active = value === current;
        var extra = werte[norm(value)] || {};
        var label = extra.label || value;
        var diff = diffFor(value);
        var cls = itemClass(look) +
          (active ? ' is-active' : '') +
          (status === 'soldout' ? ' is-soldout' : '') +
          (status === 'missing' ? ' is-missing' : '');
        var attrs = ' type="button" role="radio" aria-checked="' + active + '" data-zs-action="option" data-zs-name="' +
          esc(step.name) + '" data-zs-value="' + esc(value) + '" data-zs-focus="opt:' + esc(key) + ':' + esc(value) + '"' +
          (status !== 'ok' ? ' title="' + esc(soldoutLabel(status)) + '"' : '');

        if (tiles) {
          var variant = self.variantForValue(key, value);
          var img = extra.img || (variant && variant.image_src) || ersatzbild;
          if (img === ersatzbild) ersatzbild = '';
          html += pictureButton(look, cls, attrs, {
            img: img,
            // Farbfelder ohne eigenes Bild im Wert-Block: Farbe aus dem Namen statt Produktfoto
            farbe: look === 'swatch' && !extra.img ? farbeAusName(value) : '',
            label: label,
            desc: extra.desc,
            badge: extra.badge,
            diff: diff,
            state: status === 'soldout' ? self.settings.textAusverkauft : ''
          });
        } else {
          html += '<button class="' + cls + '"' + attrs + '>' +
            (extra.badge ? '<span class="zs-badge zs-badge--inline">' + esc(extra.badge) + '</span>' : '') +
            '<span class="zs-btn__label">' + esc(label) + '</span>' +
            (diff ? '<span class="zs-diff">' + diff + '</span>' : '') +
            '</button>';
        }
      });
      html += '</div>';

      var currentExtra = werte[norm(current)];
      if ((look === 'btn' || look === 'swatch') && currentExtra && currentExtra.desc) {
        html += '<p class="zs-step__note">' + esc(currentExtra.desc) + '</p>';
      }
      return html;
    }

    familieBody(step) {
      var self = this;
      var members = step.members.filter(function (member) { return member.product; });

      if (!members.length) {
        return DESIGN_MODE ? warn('Füge mit dem Unterblock „Produkt“ die Produkte dieser Familie hinzu.') : '';
      }

      var warnings = '';
      if (DESIGN_MODE) {
        step.members.forEach(function (member) {
          if (!member.product) {
            warnings += warn('Ein Unterblock „Produkt“ hat noch kein Produkt.');
          } else if (!sameOptions(member.product, self.mainProduct)) {
            warnings += warn('„' + esc(member.product.title) + '“ hat andere Optionen (' + esc(member.product.options.join(', ')) +
              ') als dieses Produkt (' + esc(self.mainProduct.options.join(', ')) + ').');
          }
        });
        if (step.members[0] && step.members[0].implicit) {
          warnings += warn('Das aktuelle Produkt ist nicht als Unterblock eingetragen. Es wurde automatisch vorne ergänzt.', 'info');
        }
      }

      // Je Wert ein Knopf; Ziel ist das Produkt mit diesem Wert, das die übrigen Wechsel-Werte behält
      var active = this.activeMember(step);
      var activeValue = active ? active.value : '';
      var entries = step.values.map(function (value) {
        return { value: value, member: self.targetMember(step, value) };
      }).filter(function (entry) { return entry.member; });

      if (step.display === 'dropdown') {
        return warnings + '<div class="zs-select"><select data-zs-action="member-select" data-zs-key="' + esc(step.key) + '" data-zs-focus="member:' + esc(step.key) + '" aria-label="' + esc(step.label) + '">' +
          entries.map(function (entry) {
            var status = self.memberStatus(entry.member);
            return '<option value="' + esc(entry.value) + '"' + (entry.value === activeValue ? ' selected' : '') + '>' + esc(entry.value) +
              (status === 'soldout' ? ' (' + esc(self.settings.textAusverkauft) + ')' : '') + '</option>';
          }).join('') + '</select></div>';
      }

      var look = lookFor(step.display);
      var tiles = look !== 'btn';
      var memberLabels = entries.map(function (entry) { return entry.value || ''; });
      var html = '<div class="' + containerClass(look) + '"' + gridStyle(look, memberLabels) + ' role="radiogroup" aria-label="' + esc(step.label) + '">';
      entries.forEach(function (entry) {
        var member = entry.member;
        var status = self.memberStatus(member);
        var isActive = entry.value === activeValue;
        // Nicht ausgegraut, wenn es nur die aktuelle Höhe o. Ä. nicht gibt: der Wechsel wählt dann die nächste passende Variante
        var cls = itemClass(look) +
          (isActive ? ' is-active' : '') +
          (status === 'soldout' ? ' is-soldout' : '');
        var attrs = ' type="button" role="radio" aria-checked="' + isActive + '" data-zs-action="member" data-zs-key="' + esc(step.key) +
          '" data-zs-value="' + esc(entry.value) + '" data-zs-focus="member:' + esc(step.key) + ':' + esc(entry.value) + '"';

        // Farbfelder ohne eigenes Bild: Farbe aus dem Namen (Anthrazit, Moosgrün, verzinkt)
        var farbe = look === 'swatch' && !member.img ? farbeAusName(entry.value) : '';
        if (farbe) {
          html += '<button class="' + cls + '"' + attrs + ' title="' + esc(entry.value) + '">' +
            '<span class="zs-swatch__img" style="background:' + farbe + '"></span>' +
            swatchLabel(entry.value) + '</button>';
        } else if (tiles) {
          var match = findExact(member.product, self.selection) || bestVariant(member.product, self.selection, null);
          var img = member.img || (match && match.image_src) || member.product.image || '';
          html += pictureButton(look, cls, attrs, {
            img: img,
            label: entry.value,
            state: status === 'soldout' ? self.settings.textAusverkauft : ''
          });
        } else {
          html += '<button class="' + cls + '"' + attrs + '><span class="zs-btn__label">' + esc(entry.value) + '</span></button>';
        }
      });
      return warnings + html + '</div>';
    }

    auswahlBody(step) {
      var value = this.auswahl[step.key] || '';
      var invalid = this.triedToAdd && step.pflicht && !value.trim();
      step.el.classList.toggle('is-invalid', invalid);

      if (step.display === 'text') {
        return '<input type="text" class="zs-input" data-zs-action="auswahl-text" data-zs-key="' + esc(step.key) +
          '" value="' + esc(value) + '" placeholder="' + esc(step.platzhalter || '') + '" aria-label="' + esc(step.label) + '">';
      }

      if (step.display === 'farbfelder') {
        return '<div class="zs-swatches" role="radiogroup" aria-label="' + esc(step.label) + '">' +
          step.values.map(function (option) {
            var active = option === value;
            var farbe = step.farben[option] || '#c5cfd8';
            return '<button type="button" class="zs-swatch' + (active ? ' is-active' : '') + '" role="radio" aria-checked="' + active +
              '" title="' + esc(option) + '" data-zs-action="auswahl" data-zs-key="' + esc(step.key) + '" data-zs-value="' + esc(option) +
              '" data-zs-focus="auswahl:' + esc(step.key) + ':' + esc(option) + '">' +
              '<span class="zs-swatch__img" style="background:' + esc(farbe) + '"></span>' +
              swatchLabel(option) + '</button>';
          }).join('') + '</div>';
      }

      if (step.display === 'dropdown') {
        return '<div class="zs-select"><select data-zs-action="auswahl-select" data-zs-key="' + esc(step.key) +
          '" data-zs-focus="auswahl:' + esc(step.key) + '" aria-label="' + esc(step.label) + '">' +
          '<option value=""' + (value ? '' : ' selected') + '>Bitte wählen</option>' +
          step.values.map(function (option) {
            return '<option value="' + esc(option) + '"' + (option === value ? ' selected' : '') + '>' + esc(option) + '</option>';
          }).join('') + '</select></div>';
      }

      return '<div class="zs-btns"' + gridStyle('btn', step.values) + ' role="radiogroup" aria-label="' + esc(step.label) + '">' +
        step.values.map(function (option) {
          var active = option === value;
          return '<button type="button" class="zs-btn' + (active ? ' is-active' : '') + '" role="radio" aria-checked="' + active +
            '" data-zs-action="auswahl" data-zs-key="' + esc(step.key) + '" data-zs-value="' + esc(option) +
            '" data-zs-focus="auswahl:' + esc(step.key) + ':' + esc(option) + '"><span class="zs-btn__label">' + esc(option) + '</span>' +
            (step.hinweise[option] ? '<span class="zs-diff">' + esc(step.hinweise[option]) + '</span>' : '') + '</button>';
        }).join('') + '</div>';
    }

    zusatzBody(step) {
      var product = step.product;
      if (!product) return DESIGN_MODE ? warn('Bei „' + esc(step.titel) + '“ ist noch kein Produkt ausgewählt.') : '';

      var self = this;
      var state = this.zusatz[step.key];
      var variant = this.addonVariant(step);
      var max = this.addonMax(step);
      var orderable = !!variant && max > 0;
      var active = this.addonActive(step);
      var qty = this.addonQty(step);
      var img = step.bild || (variant && variant.image_src) || product.image;

      // Nicht bestellbare optionale Zusätze automatisch abwählen
      if (!orderable && step.mode !== 'pflicht' && active) {
        if (step.display === 'menge') state.qty = 0;
        else state.on = false;
        active = false;
      }

      var compare = variant && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
      var saving = compare ? Math.round((1 - variant.price / compare) * 100) : 0;
      var title = step.titel || product.title;

      var html = '<div class="zs-card' + (step.layout === 'zeile' ? ' zs-card--row' : '') + (active ? ' is-on' : '') +
        (orderable ? '' : ' is-unavailable') + '">';
      html += '<div class="zs-card__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
        (saving > 0 ? '<span class="zs-card__save">−' + saving + ' %</span>' : '') + '</div>';
      html += '<div class="zs-card__content">';
      var hasHelp = !!step.el.querySelector(':scope > .zs-step__help');
      html += '<div class="zs-card__title">' + esc(title) +
        (hasHelp ? ' <button type="button" class="zs-info" data-zs-action="help" data-zs-title="' + esc(title) + '" aria-label="Info zu ' + esc(title) + '">i</button>' : '') +
        (step.badge ? ' <span class="zs-badge zs-badge--inline">' + esc(step.badge) + '</span>' : '') + '</div>';
      if (step.beschreibung) html += '<p class="zs-card__desc">' + esc(step.beschreibung) + '</p>';

      if (step.variante === 'kunde' && !hasOnlyDefaultVariant(product)) {
        html += '<div class="zs-select zs-select--small"><select data-zs-action="zusatz-variant" data-zs-key="' + esc(step.key) +
          '" data-zs-focus="zv:' + esc(step.key) + '" aria-label="Variante">' +
          product.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (variant && v.id === variant.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
              esc(v.title) + ', ' + self.money(v.price) + (v.available ? '' : ' (' + esc(self.settings.textAusverkauft) + ')') + '</option>';
          }).join('') + '</select></div>';
      } else if (step.variante === 'passend' && this.addonMatches(step).length > 1) {
        html += '<div class="zs-select zs-select--small"><select data-zs-action="zusatz-variant" data-zs-key="' + esc(step.key) +
          '" data-zs-focus="zv:' + esc(step.key) + '" aria-label="Ausführung">' +
          this.addonMatches(step).map(function (v) {
            return '<option value="' + v.id + '"' + (variant && v.id === variant.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
              esc(v.title) + ', ' + self.money(v.price) + (v.available ? '' : ' (' + esc(self.settings.textAusverkauft) + ')') + '</option>';
          }).join('') + '</select></div>';
      } else if (variant && !hasOnlyDefaultVariant(product)) {
        html += '<p class="zs-card__variant">' + esc(variant.title) + '</p>';
      }

      if (!variant) {
        html += '<p class="zs-card__warn">' + (step.mode === 'pflicht' ? 'Kein passendes Produkt für diese Auswahl' : 'Für diese Auswahl nicht erhältlich') + '</p>';
      } else if (!orderable) {
        html += '<p class="zs-card__warn">' + esc(this.settings.textAusverkauft) + '</p>';
      } else {
        var info = this.stockInfo(variant);
        if (info.level === 'low') html += '<p class="zs-card__stock">' + esc(info.text) + '</p>';
      }

      html += '<div class="zs-card__footer">';
      html += '<div class="zs-card__price">' + (variant
        ? (qty > 1 && active ? '<span class="zs-card__qty">' + qty + ' ×</span> ' : '') +
          (compare ? '<s>' + this.money(compare) + '</s> ' : '') + '<strong>' + this.money(variant.price) + '</strong>'
        : '') + '</div>';

      if (step.display === 'menge') {
        var min = step.mode === 'pflicht' ? 1 : 0;
        html += '<div class="zs-qty zs-qty--small">' +
          '<button type="button" class="zs-qty__btn" data-zs-action="zusatz-qty" data-zs-key="' + esc(step.key) + '" data-zs-delta="-1"' +
          (state.qty <= min ? ' disabled' : '') + ' aria-label="Weniger" data-zs-focus="zq-:' + esc(step.key) + '">−</button>' +
          '<span class="zs-qty__value">' + state.qty + '</span>' +
          '<button type="button" class="zs-qty__btn" data-zs-action="zusatz-qty" data-zs-key="' + esc(step.key) + '" data-zs-delta="1"' +
          (!orderable || state.qty >= max ? ' disabled' : '') + ' aria-label="Mehr" data-zs-focus="zq+:' + esc(step.key) + '">+</button>' +
          '</div>';
      } else if (step.mode === 'pflicht') {
        html += '<span class="zs-card__required">Wird automatisch hinzugefügt</span>';
      } else {
        html += '<button type="button" class="zs-check' + (active ? ' is-on' : '') + '" role="switch" aria-checked="' + active +
          '" data-zs-action="zusatz-toggle" data-zs-key="' + esc(step.key) + '" data-zs-focus="zt:' + esc(step.key) + '"' +
          (orderable ? '' : ' disabled') + '><span class="zs-check__box" aria-hidden="true"></span><span>' +
          esc(active ? 'Hinzugefügt' : (step.buttonText || 'Hinzufügen')) + '</span></button>';
      }
      html += '</div></div></div>';
      return html;
    }

    galleryMedia() {
      var product = this.product;
      var media = product.media || [];
      if (!this.settings.galleryFilter || !media.length) return media;

      var allValues = [];
      product.options.forEach(function (name, i) {
        uniqueValues(product, i).forEach(function (value) { allValues.push(words(value)); });
      });
      var self = this;
      var selected = Object.keys(this.selection).map(function (key) { return words(self.selection[key]); });

      var filtered = media.filter(function (item) {
        var alt = words(item.alt);
        var mentioned = allValues.filter(function (value) { return value.trim() && alt.indexOf(value) !== -1; });
        if (!mentioned.length) return true;
        return mentioned.some(function (value) { return selected.indexOf(value) !== -1; });
      });
      return filtered.length ? filtered : media;
    }

    // Bilder mit Maßen im Dateinamen (Doppeltor_3000_1200_Front.jpg): passendes Bild über den Namen statt über
    // die Variantenzuordnung in Shopify, die teils falsch ist. Ohne Treffer das Titelbild statt eines falschen Maßes.
    bildNachDateiname(variant) {
      var media = this.product.media || [];
      if (!variant || media.length < 3) return null;
      var zahlen = function (text) {
        var out = [];
        String(text || '').replace(/(?:^|[_\-. ])(\d{3,4})(?=[_\-. ]|mm|$)/gi, function (m, n) { out.push(Number(n)); return m; });
        return out;
      };
      var datei = function (src) { return String(src || '').split('?')[0].split('/').pop(); };
      var mitMassen = media.filter(function (m) { return zahlen(datei(m.src)).length >= 2; });
      if (mitMassen.length < media.length / 2) return null;
      var gesucht = [];
      variant.options.forEach(function (wert) { zahlen(wert).forEach(function (n) { gesucht.push(n); }); });
      if (gesucht.length < 2) return null;
      var treffer = mitMassen.filter(function (m) {
        var z = zahlen(datei(m.src));
        return gesucht.every(function (n) { return z.indexOf(n) !== -1; });
      });
      treffer.sort(function (a, b) { return (/front/i.test(datei(b.src)) ? 1 : 0) - (/front/i.test(datei(a.src)) ? 1 : 0); });
      var bild = treffer[0] || media[0];
      return bild ? { id: bild.id, src: bild.src, alt: bild.alt || this.product.title } : null;
    }

    stageImage(media) {
      var variant = this.currentVariant();
      var self = this;

      if (this.galleryPick) {
        var picked = media.filter(function (item) { return item.id === self.galleryPick; })[0];
        if (picked) return { id: picked.id, src: picked.src, alt: picked.alt };
      }
      if (this.stageOverride) return this.stageOverride;
      // Auswahl mit Bild je Wert (z. B. Farbe des Schiebetors)
      for (var k = 0; k < this.steps.length; k++) {
        var bildStep = this.steps[k];
        if (bildStep.type !== 'auswahl' || !bildStep.bilder || !this.isVisible(bildStep)) continue;
        var bildWert = this.auswahl[bildStep.key];
        if (bildWert && bildStep.bilder[bildWert]) return { id: null, src: bildStep.bilder[bildWert], alt: bildWert };
      }
      var perName = this.bildNachDateiname(variant);
      if (perName) return perName;
      if (variant && variant.image_src) return { id: variant.image_id, src: variant.image_src, alt: variant.title };

      // Ohne Variantenbild: Hauptbild des aktiven Produkts (z. B. Eckpfosten), erst danach Bilder aus den Blöcken
      if (media[0]) return { id: media[0].id, src: media[0].src, alt: media[0].alt };
      if (this.product.image) return { id: null, src: this.product.image, alt: this.product.title };
      var member = this.activeMember();
      if (member && member.img) return { id: null, src: member.img, alt: member.value };
      // Auswahl mit Bild je Wert (z. B. Farbe des Schiebetors)
      for (var j = 0; j < this.steps.length; j++) {
        var auswahlStep = this.steps[j];
        if (auswahlStep.type !== 'auswahl' || !auswahlStep.bilder || !this.isVisible(auswahlStep)) continue;
        var gewaehlt = this.auswahl[auswahlStep.key];
        if (gewaehlt && auswahlStep.bilder[gewaehlt]) return { id: null, src: auswahlStep.bilder[gewaehlt], alt: gewaehlt };
      }
      for (var i = 0; i < this.steps.length; i++) {
        var step = this.steps[i];
        if (step.type !== 'option') continue;
        var extra = step.werte[norm(this.selection[norm(step.name)])];
        if (extra && extra.img) return { id: null, src: extra.img, alt: this.selection[norm(step.name)] };
      }
      return null;
    }

    renderGallery() {
      var img = this.querySelector('[data-zs-main-img]');
      var thumbs = this.querySelector('[data-zs-thumbs]');
      if (!img) return;

      var media = this.galleryMedia().slice();
      var stage = this.stageImage(media);

      if (stage && stage.id && !media.some(function (item) { return item.id === stage.id; })) {
        var original = (this.product.media || []).filter(function (item) { return item.id === stage.id; })[0];
        if (original) media.unshift(original);
      }

      if (stage) {
        if (img.getAttribute('src') !== stage.src) {
          img.classList.add('is-loading');
          img.onload = function () { img.classList.remove('is-loading'); };
          img.removeAttribute('width');
          img.removeAttribute('height');
          img.src = stage.src;
        }
        img.alt = stage.alt || this.product.title;
        img.hidden = false;
      }

      if (thumbs) {
        thumbs.innerHTML = media.length > 1 ? media.map(function (item) {
          var active = stage && stage.id === item.id;
          return '<button type="button" class="zs-thumb' + (active ? ' is-active' : '') + '" data-zs-action="thumb" data-zs-media="' + item.id +
            '" aria-label="Bild anzeigen"><img src="' + esc(item.thumb) + '" alt="' + esc(item.alt) + '" loading="lazy"></button>';
        }).join('') : '';
      }
    }

    // Anzeigename eines Werts aus "Bild & Text für Wert", sonst der Wert selbst
    valueLabel(optionName, value) {
      var step = this.steps.find(function (s) { return s.type === 'option' && norm(s.name) === norm(optionName); });
      var extra = step && step.werte ? step.werte[norm(value)] : null;
      return (extra && extra.label) || value;
    }

    summaryLines() {
      var lines = [];
      var self = this;
      var variant = this.currentVariant();

      if (variant) {
        var teile = titelOhneFarbe(this.product.title);
        var optionen = variant.title === DEFAULT_TITLE ? '' : variant.options.map(function (value, index) {
          return self.valueLabel(self.product.options[index], value);
        }).join(' / ');
        lines.push({
          title: teile.titel,
          sub: [teile.farbe, optionen].filter(Boolean).join(' / '),
          qty: this.qty,
          price: variant.price * this.qty,
          compare: variant.compare_at_price > variant.price ? variant.compare_at_price * this.qty : 0
        });
      }

      this.steps.forEach(function (step) {
        if (step.type === 'auswahl' && self.isVisible(step) && self.auswahl[step.key]) {
          lines.push({ info: true, title: step.label, sub: self.auswahl[step.key] });
        }
        if (!self.addonActive(step)) return;
        var addon = self.addonVariant(step);
        if (!addon) return;
        var qty = self.addonQty(step);
        lines.push({
          title: step.titel || step.product.title,
          sub: addon.title === DEFAULT_TITLE ? '' : addon.title,
          qty: qty,
          price: addon.price * qty,
          compare: 0
        });
      });
      return lines;
    }

    // Lieferdatum passend zum Bestand: bei Nachbestellung die längere Lieferzeit aus den Shop-Infos
    // oder, wenn keine eingetragen ist, kein Datum versprechen
    lieferzeitFuer(info) {
      var el = this.querySelector('.zs-ship [data-zs-lieferdatum]');
      if (!el) return;
      if (this.settings.lieferhinweis) {
        el.setAttribute('data-zs-done', '');
        el.textContent = this.settings.lieferhinweis;
        el.removeAttribute('title');
        return;
      }
      // Normaler Bestand und nie umgestellt: zs-shop.js schreibt das Datum wie überall im Shop
      // Produkt mit eigener Lieferzeit (Metafeld, z. B. Schiebetor): gilt immer, egal ob Bestand geführt wird
      if (this.settings.lieferzeitProdukt) info = Object.assign({}, info, { nachbestellt: true });
      if (!(info && info.nachbestellt) && !el.hasAttribute('data-zs-normal')) return;
      if (!el.hasAttribute('data-zs-normal')) {
        el.setAttribute('data-zs-normal', el.getAttribute('data-min') + '|' + el.getAttribute('data-max'));
      }
      var normal = el.getAttribute('data-zs-normal').split('|').map(Number);
      var min = normal[0];
      var max = normal[1];
      if (info && info.nachbestellt) {
        min = Number(this.settings.nachbestelltMin) || 0;
        max = Number(this.settings.nachbestelltMax) || min;
        // Vertauscht eingetragen (z. B. min 42, max 38): trotzdem den richtigen Zeitraum zeigen
        if (max < min) { var tausch = min; min = max; max = tausch; }
        if (!min) min = max;
      }
      var zeitraum = window.zsShop && window.zsShop.lieferzeitraum;
      el.setAttribute('data-zs-done', '');
      if (min > 0 && max >= min) {
        el.textContent = zeitraum ? 'voraussichtlich ' + zeitraum(min, max) : 'in ' + min + ' bis ' + max + ' Werktagen';
        el.setAttribute('title', min + ' bis ' + max + ' Werktage');
      } else {
        el.textContent = 'nach Absprache, wir melden uns mit dem Termin';
        el.removeAttribute('title');
      }
    }

    renderSummary() {
      var self = this;
      var variant = this.currentVariant();
      var lines = this.summaryLines();
      var total = lines.reduce(function (sum, line) { return sum + (line.price || 0); }, 0);

      // Nur ein Artikel ohne Zusätze: Preis steht schon groß darunter, die Zeile zeigt nur die Ausführung
      var priced = lines.filter(function (line) { return !line.info; });
      var single = priced.length === 1 && priced[0].qty <= 1;
      // Gesamtpreis steht immer im Kasten mit dem Button, auch bei einem Artikel
      var totalLabel = this.querySelector('[data-zs-total-label]');
      if (totalLabel) totalLabel.hidden = false;
      // Nur ein Artikel: der Preis steht schon oben unter dem Titel, unten kein zweites Mal.
      // Ohne Ausführung (Standardvariante) und ohne Zusätze auch keine Zeile „Ihre Auswahl“, sie wiederholt nur den Titel.
      // Einfacher Artikel (keine Auswahlschritte, keine Varianten): Preis nur im Kasten mit dem Button, oben ausblenden
      var einfach = hasOnlyDefaultVariant(this.product) && !this.steps.some(function (step) {
        return ['option', 'familie', 'zusatz', 'auswahl'].indexOf(step.type) !== -1;
      });
      var priceRow = this.querySelector('.zs-konfig__price-row');
      if (priceRow) priceRow.hidden = einfach;
      var totalRow = this.querySelector('.zs-summary__total');
      if (totalRow) totalRow.hidden = false;
      var nurTitel = single && lines.length === 1 && !priced[0].sub;
      var summaryTitle = this.querySelector('.zs-summary__title');
      if (summaryTitle) summaryTitle.hidden = nurTitel;
      var list = this.querySelector('[data-zs-lines]');
      if (list) {
        list.hidden = nurTitel;
        list.classList.toggle('is-single', single);
        list.innerHTML = lines.map(function (line) {
          // Ein Artikel: gleiche Zeile wie mit Zusätzen (Produkt, darunter die Ausführung), nur ohne Preis
          if (single && !line.info) {
            return '<li class="zs-line"><span class="zs-line__name">' + esc(line.title) +
              (line.sub ? '<small>' + esc(line.sub) + '</small>' : '') + '</span></li>';
          }
          if (line.info) {
            return '<li class="zs-line zs-line--info"><span class="zs-line__name">' + esc(line.title) + ': ' + esc(line.sub) + '</span></li>';
          }
          return '<li class="zs-line"><span class="zs-line__name">' + (line.qty > 1 ? line.qty + ' × ' : '') + esc(line.title) +
            (line.sub ? '<small>' + esc(line.sub) + '</small>' : '') + '</span>' +
            '<span class="zs-line__price">' + (line.compare ? '<s>' + self.money(line.compare) + '</s> <span class="is-sale">' + self.money(line.price) + '</span>' : self.money(line.price)) + '</span></li>';
        }).join('');
      }

      // Vergleichspreise (compare_at_price): Gesamtpreis rot, Summe ohne Rabatt durchgestrichen, Ersparnis darunter
      var compareTotal = lines.reduce(function (sum, line) { return line.info ? sum : sum + (line.compare || line.price || 0); }, 0);
      // Mengenrabatt (Staffel aus den Shop-Infos, Konfiguration + Warenkorb) schon hier abziehen und zeigen
      var stufe = this.mengenrabatt(total + (this.cartTotal || 0));
      var endTotal = stufe ? Math.round(total * (1 - stufe.pct / 100)) : total;
      var basisTotal = Math.max(compareTotal, total);
      // Nur ein Artikel: Angebot steht schon groß oben am Preis, unten nur der Preis ohne Wiederholung
      var totalSale = basisTotal > endTotal;
      this.querySelectorAll('[data-zs-total]').forEach(function (el) {
        el.innerHTML = self.money(endTotal);
        el.classList.toggle('is-sale', totalSale);
      });
      this.querySelectorAll('[data-zs-total-compare]').forEach(function (el) {
        el.textContent = totalSale ? self.money(basisTotal) : '';
        el.hidden = !totalSale;
      });
      this.querySelectorAll('[data-zs-total-save]').forEach(function (el) {
        el.textContent = totalSale
          ? 'Sie sparen ' + self.money(basisTotal - endTotal) + (stufe ? ' (inkl. ' + stufe.pct + ' % Mengenrabatt)' : '')
          : '';
        el.hidden = !totalSale;
      });

      var title = this.querySelector('[data-zs-title]');
      var anzeigeTitel = titelOhneFarbe(this.product.title).titel;
      if (title && title.textContent !== anzeigeTitel) title.textContent = anzeigeTitel;

      var price = this.querySelector('[data-zs-price]');
      if (price && variant) {
        var reduziert = variant.compare_at_price > variant.price;
        price.innerHTML = '<span' + (reduziert ? ' class="is-sale"' : '') + '>' + this.money(variant.price) + '</span>' +
          (reduziert ? ' <s>' + this.money(variant.compare_at_price) + '</s>' +
            '<span class="zs-konfig__save">Sie sparen ' + this.money(variant.compare_at_price - variant.price) + '</span>' : '');
      }

      var info = this.stockInfo(variant);
      var stock = this.querySelector('[data-zs-stock]');
      if (stock) {
        stock.className = 'zs-stock zs-stock--' + info.level;
        stock.textContent = info.text;
      }
      this.lieferzeitFuer(info);

      var max = this.mainMaxQty();
      var input = this.querySelector('[data-zs-action="qty-input"]');
      if (input) {
        input.value = this.qty;
        input.max = Math.max(1, max);
      }
      var minus = this.querySelector('[data-zs-action="qty"][data-zs-delta="-1"]');
      var plus = this.querySelector('[data-zs-action="qty"][data-zs-delta="1"]');
      if (minus) minus.disabled = this.qty <= 1;
      if (plus) plus.disabled = this.qty >= max;

      var orderable = !!variant && max > 0;
      this.querySelectorAll('[data-zs-action="add"]').forEach(function (button) {
        button.disabled = !orderable || self._busy;
        var text = self._busy ? 'Wird hinzugefügt …' : (orderable ? self.settings.textButton : (variant ? self.settings.textAusverkauft : 'Nicht erhältlich'));
        // Hauptbutton zeigt den Gesamtpreis direkt mit an
        if (button.hasAttribute('data-zs-add-price') && orderable && !self._busy) {
          button.innerHTML = '<span>' + esc(text) + '</span><span class="zs-add__price">' + self.money(endTotal) + '</span>';
        } else {
          button.textContent = text;
        }
      });

      this.renderShipping(total);

      if (this.triedToAdd) this.showProblems(this.problems(), false);
    }

    // Staffelrabatt aus den Theme-Einstellungen, Format "199900:10,399900:20," (leer, wenn das Produkt nicht rabattfähig ist)
    rabattStufen() {
      var box = this.querySelector('[data-zs-ship]');
      return String((box && box.getAttribute('data-stufen')) || '').split(',').map(function (teil) {
        var paar = teil.split(':');
        return { ab: parseInt(paar[0], 10), pct: Number(paar[1]) };
      }).filter(function (stufe) { return stufe.ab > 0 && stufe.pct > 0; }).sort(function (a, b) { return a.ab - b.ab; });
    }

    mengenrabatt(summe) {
      return this.rabattStufen().filter(function (stufe) { return stufe.ab <= summe; }).pop() || null;
    }

    // Fortschritt bis zum kostenlosen Versand (Konfiguration + Warenkorb)
    renderShipping(total) {
      var box = this.querySelector('[data-zs-ship]');
      var label = box && box.querySelector('[data-zs-ship-label]');
      if (!label) return;
      var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 0;
      var sum = total + (this.cartTotal || 0);
      var reached = sum >= threshold;
      var stufen = this.rabattStufen();
      var naechste = stufen.filter(function (stufe) { return stufe.ab > sum; })[0];
      var erreicht = stufen.filter(function (stufe) { return stufe.ab <= sum; }).pop();
      var ziel = reached ? (naechste ? naechste.ab : 0) : threshold;

      box.classList.toggle('is-free', reached);
      if (!reached) {
        label.innerHTML = 'Noch <strong>' + this.money(threshold - sum) + '</strong> bis zum kostenlosen Versand';
      } else if (naechste) {
        label.innerHTML = '<strong>Versandkostenfrei</strong>' + (erreicht ? ' · ' + erreicht.pct + ' % Rabatt' : '') +
          ' · noch ' + this.money(naechste.ab - sum) + ' bis ' + naechste.pct + ' % Rabatt';
      } else if (erreicht) {
        label.innerHTML = '<strong>Versandkostenfrei · ' + erreicht.pct + ' % Rabatt</strong> ist im Preis schon abgezogen';
      } else {
        label.innerHTML = '<strong>Kostenloser Versand</strong> für diese Bestellung';
      }
      var bar = box.querySelector('[data-zs-ship-bar]');
      if (bar) bar.style.width = (ziel ? Math.min(100, Math.round(sum / ziel * 100)) : 100) + '%';

      // Unter der Versandschwelle schon auf den Mengenrabatt hinweisen
      var rabatt = box.querySelector('[data-zs-rabatt]');
      if (rabatt) {
        var hoechste = stufen[stufen.length - 1];
        rabatt.hidden = reached || !naechste;
        if (!reached && naechste) {
          rabatt.innerHTML = 'Ab <strong>' + this.money(naechste.ab) + '</strong> sparen Sie automatisch ' + naechste.pct + ' %' +
            (hoechste && hoechste !== naechste ? ', ab ' + this.money(hoechste.ab) + ' sogar ' + hoechste.pct + ' %' : '');
        }
      }
    }

    // Konfiguration als E-Mail-Entwurf, z. B. zum Weiterleiten an Partner oder Nachbarn
    mailConfiguration(button) {
      var self = this;
      var variant = this.currentVariant();
      var lines = this.summaryLines();
      var total = lines.reduce(function (sum, line) { return sum + (line.price || 0); }, 0);
      var text = lines.map(function (line) {
        if (line.info) return line.title + ': ' + line.sub;
        return (line.qty > 1 ? line.qty + ' × ' : '') + line.title + (line.sub ? ' (' + line.sub + ')' : '') +
          ': ' + self.money(line.price).replace(/<[^>]+>/g, '');
      }).join('\n');
      var url = window.location.origin + this.product.url + (variant ? '?variant=' + variant.id : '');
      var body = 'Meine Konfiguration bei ZaunScout:\n\n' + text + '\n\nGesamtpreis: ' +
        this.money(total).replace(/<[^>]+>/g, '') + ' (inkl. MwSt., zzgl. Versand)';
      var titel = 'Meine Konfiguration: ' + this.product.title;
      if (window.zsShop && window.zsShop.teilen && button) {
        window.zsShop.teilen({ titel: titel, text: body, url: url }, button);
        return;
      }
      window.location.href = 'mailto:?subject=' + encodeURIComponent(titel) +
        '&body=' + encodeURIComponent(body + '\n\n' + url);
    }

    renderDesignInfo() {
      var box = this.querySelector('[data-zs-design]');
      if (!box) return;
      var self = this;
      var covered = this.coveredOptions();
      var items = [];

      if (!hasOnlyDefaultVariant(this.mainProduct)) {
        items.push('<strong>Optionen dieses Produkts:</strong> ' + this.mainProduct.options.map(function (name) {
          return esc(name) + (covered[norm(name)] ? ' (eigener Block)' : ' (automatisch)');
        }).join(', '));
      }

      this.allProducts().forEach(function (product) {
        var missing = product.variants.filter(function (v) { return !v.image_src; });
        if (missing.length) {
          items.push('<strong>' + esc(product.title) + ':</strong> ' + missing.length + ' von ' + product.variants.length +
            ' Varianten ohne eigenes Bild (z. B. ' + esc(missing.slice(0, 3).map(function (v) { return v.title; }).join(', ')) + ').');
        }
        var unmanaged = product.variants.filter(function (v) { return !v.managed; }).length;
        if (unmanaged) {
          items.push('<strong>' + esc(product.title) + ':</strong> ' + unmanaged + ' Varianten ohne Bestandsführung. Dort kann der Konfigurator keinen Bestand prüfen.');
        }
        var resell = product.variants.filter(function (v) { return v.managed && v.policy === 'continue'; }).length;
        if (resell) {
          items.push('<strong>' + esc(product.title) + ':</strong> „Weiterverkaufen, wenn ausverkauft“ ist bei ' + resell +
            ' Varianten an. Ohne Bestand erscheint dort „' + esc(self.settings.textNachbestellt) + '“.');
        }
        if (product.variants.length >= 250) {
          items.push('<strong>' + esc(product.title) + ':</strong> 250 oder mehr Varianten. Shopify gibt nur die ersten 250 an die Seite. Bitte als Produktwechsel aufteilen.');
        }
      });

      this.steps.forEach(function (step) {
        if (step.condStep) {
          var known = self.steps.some(function (other) {
            return other !== step && (norm(other.label) === step.condStep || (other.type === 'option' && norm(other.name) === step.condStep));
          }) || optionIndex(self.product, step.condStep) !== -1;
          if (!known) items.push('Bedingung bei „' + esc(step.label || step.type) + '“: Schritt „' + esc(step.condStep) + '“ nicht gefunden.');
        }
      });

      box.hidden = !items.length;
      box.innerHTML = items.length
        ? '<p class="zs-design__title">Hinweise für den Theme-Editor (nur hier sichtbar)</p><ul>' +
          items.map(function (item) { return '<li>' + item + '</li>'; }).join('') + '</ul>'
        : '';
    }

    updateUrl() {
      var variant = this.currentVariant();
      if (!variant || !window.history || !window.history.replaceState || DESIGN_MODE) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url.toString());
    }

    /* ----- Prüfen und Warenkorb ----- */

    problems() {
      var list = [];
      var self = this;
      var variant = this.currentVariant();

      if (!variant) list.push({ msg: 'Diese Kombination gibt es nicht. Bitte wähle eine andere.' });
      else if (!variant.available) list.push({ msg: this.product.title + ': ' + this.settings.textAusverkauft + '.' });
      else if (this.qty > this.mainMaxQty()) list.push({ msg: 'Es sind nur noch ' + this.mainMaxQty() + ' Stück verfügbar.' });

      this.steps.forEach(function (step) {
        if (!self.isVisible(step)) return;
        if (step.type === 'auswahl' && step.pflicht && !String(self.auswahl[step.key] || '').trim()) {
          list.push({ msg: 'Bitte „' + step.label + '“ wählen.', step: step });
        }
        if (step.type === 'zusatz' && self.addonActive(step)) {
          var addon = self.addonVariant(step);
          var name = step.titel || step.product.title;
          if (!addon) list.push({ msg: name + ': kein passendes Produkt für diese Auswahl.', step: step });
          else if (self.addonQty(step) > self.maxQty(addon)) {
            list.push({ msg: name + ': nicht genug auf Lager (verfügbar: ' + self.maxQty(addon) + ').', step: step });
          }
        }
      });
      return list;
    }

    showProblems(list, scroll) {
      var box = this.querySelector('[data-zs-errors]');
      this.steps.forEach(function (step) {
        if (step.type !== 'auswahl') step.el.classList.remove('is-invalid');
      });
      list.forEach(function (problem) {
        if (problem.step) problem.step.el.classList.add('is-invalid');
      });
      if (box) {
        box.hidden = !list.length;
        box.innerHTML = list.map(function (problem) { return '<p>' + esc(problem.msg) + '</p>'; }).join('');
      }
      if (scroll && list.length) {
        var first = list.filter(function (problem) { return problem.step; })[0];
        (first ? first.step.el : box).scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    loadCart() {
      var self = this;
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          self.cartQty = {};
          self.cartTotal = cart.total_price || 0;
          (cart.items || []).forEach(function (item) {
            self.cartQty[item.variant_id] = (self.cartQty[item.variant_id] || 0) + item.quantity;
          });
          self.qty = clamp(self.qty, 1, Math.max(1, self.mainMaxQty()));
          self.render();
          return cart;
        })
        .catch(function () { return null; });
    }

    setBusy(busy) {
      this._busy = busy;
      this.classList.toggle('is-busy', busy);
      this.renderSummary();
    }

    addToCart() {
      if (this._busy) return;
      this.triedToAdd = true;
      var success = this.querySelector('[data-zs-success]');
      if (success) success.hidden = true;

      var list = this.problems();
      this.renderSteps();
      this.showProblems(list, true);
      if (list.length) return;

      var self = this;
      var variant = this.currentVariant();
      var konfigId = 'zs' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var mainTitle = this.product.title + (variant.title === DEFAULT_TITLE ? '' : ', ' + variant.title);

      var properties = {};
      this.steps.forEach(function (step) {
        if (step.type === 'auswahl' && self.isVisible(step) && String(self.auswahl[step.key] || '').trim()) {
          properties[step.label] = String(self.auswahl[step.key]).trim();
        }
      });
      properties._konfig_id = konfigId;
      properties._konfig_rolle = 'haupt';

      var items = [{ id: variant.id, quantity: this.qty, properties: properties }];
      var tracking = [{ item_id: String(variant.sku || variant.id), item_name: this.product.title, item_variant: variant.title, price: variant.price / 100, quantity: this.qty }];

      this.steps.forEach(function (step) {
        if (!self.addonActive(step)) return;
        var addon = self.addonVariant(step);
        if (!addon) return;
        var addonProps = { 'Gehört zu': mainTitle, _konfig_id: konfigId, _konfig_rolle: 'zusatz' };
        if (step.display !== 'menge' && step.gekoppelt) {
          addonProps._konfig_pro_stueck = String(Math.max(1, Number(step.mengePro) || 1));
        }
        var qty = self.addonQty(step);
        items.push({ id: addon.id, quantity: qty, properties: addonProps });
        tracking.push({ item_id: String(addon.sku || addon.id), item_name: step.product.title, item_variant: addon.title, price: addon.price / 100, quantity: qty });
      });

      this.setBusy(true);

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (body) { return { ok: response.ok, body: body }; });
        })
        .then(function (result) {
          if (!result.ok) {
            var message = (result.body && (result.body.description || result.body.message)) || 'Die Konfiguration konnte nicht in den Warenkorb gelegt werden.';
            return self.rollback(konfigId).then(function () { throw new Error(message); });
          }
          self.track('in_warenkorb', {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
            value: tracking.reduce(function (sum, item) { return sum + item.price * item.quantity; }, 0),
            items: tracking
          });
          self.triedToAdd = false;
          self.showProblems([], false);
          return self.loadCart().then(function () { self.afterAdd(result.body); });
        })
        .catch(function (error) {
          self.showProblems([{ msg: error.message }], true);
        })
        .then(function () {
          self.setBusy(false);
        });
    }

    // Entfernt Teile einer Konfiguration wieder, falls nur ein Teil im Warenkorb gelandet ist
    rollback(konfigId) {
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (item) {
            if (item.properties && item.properties._konfig_id === konfigId) updates[item.key] = 0;
          });
          if (!Object.keys(updates).length) return null;
          return fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .catch(function () { return null; });
    }

    afterAdd(body) {
      var mode = this.settings.afterAdd;
      var hasDrawer = window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer';

      if (mode === 'warenkorb' || (mode === 'drawer' && !hasDrawer)) {
        window.location.href = ROOT + 'cart';
        return;
      }

      if (mode === 'drawer') {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: body } }));
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:build'));
      var success = this.querySelector('[data-zs-success]');
      if (success) {
        success.innerHTML = esc(this.settings.textErfolg) + ' <a href="' + ROOT + 'cart">Zum Warenkorb</a>';
        success.hidden = false;
      }
    }

    track(name, params) {
      if (typeof window.gtag !== 'function') return;
      try {
        window.gtag('event', 'zs_konfigurator_' + name, Object.assign({ produkt: this.mainProduct.title }, params || {}));
      } catch (error) {
        /* Tracking darf den Konfigurator nie stören */
      }
    }

    preloadImages() {
      var products = this.allProducts();
      var seen = {};
      var queue = [];
      products.forEach(function (product) {
        product.variants.forEach(function (variant) {
          if (variant.image_src && !seen[variant.image_src]) {
            seen[variant.image_src] = true;
            queue.push(variant.image_src);
          }
        });
      });
      var load = function () {
        queue.slice(0, 60).forEach(function (src) {
          var image = new Image();
          image.decoding = 'async';
          image.src = src;
        });
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 3000 });
      else window.setTimeout(load, 1500);
    }
  }

  // Darstellung eines Schritts: 'tiles' (Bildkacheln), 'swatch' (runde Farbfelder) oder 'btn' (Knöpfe)
  function lookFor(display) {
    if (display === 'kacheln') return 'tiles';
    if (display === 'liste') return 'list';
    if (display === 'farbfelder') return 'swatch';
    return 'btn';
  }

  function containerClass(look) {
    return look === 'tiles' ? 'zs-tiles' : look === 'swatch' ? 'zs-swatches' : look === 'list' ? 'zs-list' : 'zs-btns';
  }

  // Spaltenzahl so wählen, dass die Reihen gleichmäßig gefüllt sind (keine Lücke rechts)
  function balancedColumns(count, max) {
    if (count <= max) return count;
    var rows = Math.ceil(count / max);
    return Math.ceil(count / rows);
  }

  function gridStyle(look, labels) {
    var count = Math.max(1, labels.length);
    var longest = labels.reduce(function (max, label) { return Math.max(max, String(label).length); }, 0);
    var desktop;
    var mobile;
    if (look === 'tiles') {
      desktop = balancedColumns(count, 4);
      mobile = count === 3 ? 1 : Math.min(count, 2);
    } else if (look === 'list') {
      desktop = count > 1 ? 2 : 1;
      mobile = 1;
    } else if (look === 'swatch') {
      return '';
    } else if (longest > 18) {
      desktop = Math.min(count, 2);
      mobile = 1;
    } else if (longest > 11) {
      desktop = balancedColumns(count, 3);
      mobile = Math.min(count, 2);
    } else {
      desktop = balancedColumns(count, 6);
      mobile = balancedColumns(count, 4);
    }
    return ' style="--zs-cols: ' + desktop + '; --zs-cols-m: ' + mobile + ';"';
  }

  function itemClass(look) {
    return look === 'tiles' ? 'zs-tile' : look === 'swatch' ? 'zs-swatch' : look === 'list' ? 'zs-row' : 'zs-btn';
  }

  function pictureButton(look, cls, attrs, item) {
    var image = item.img ? '<img src="' + esc(item.img) + '" alt="" loading="lazy">' : '';
    if (look === 'list') {
      return '<button class="' + cls + '"' + attrs + '>' +
        '<span class="zs-row__img">' + image + '</span>' +
        '<span class="zs-row__text">' +
        '<span class="zs-row__label">' + esc(item.label) +
        (item.badge ? ' <span class="zs-badge zs-badge--inline">' + esc(item.badge) + '</span>' : '') + '</span>' +
        (item.desc ? '<span class="zs-row__desc">' + esc(item.desc) + '</span>' : '') +
        (item.state ? '<span class="zs-tile__state">' + esc(item.state) + '</span>' : '') +
        '</span>' +
        (item.diff ? '<span class="zs-row__diff">' + item.diff + '</span>' : '') +
        '</button>';
    }
    if (look === 'swatch') {
      return '<button class="' + cls + '"' + attrs + (attrs.indexOf(' title=') === -1 ? ' title="' + esc(item.label) + '"' : '') + '>' +
        (item.farbe
          ? '<span class="zs-swatch__img" style="background:' + item.farbe + '"></span>'
          : '<span class="zs-swatch__img">' + image + '</span>') +
        swatchLabel(item.label) +
        (item.diff ? '<span class="zs-diff">' + item.diff + '</span>' : '') +
        '</button>';
    }
    return '<button class="' + cls + '"' + attrs + '>' +
      (item.badge ? '<span class="zs-badge">' + esc(item.badge) + '</span>' : '') +
      '<span class="zs-tile__img">' + image + '</span>' +
      '<span class="zs-tile__label">' + esc(item.label) + '</span>' +
      (item.desc ? '<span class="zs-tile__desc">' + esc(item.desc) + '</span>' : '') +
      (item.diff ? '<span class="zs-diff">' + item.diff + '</span>' : '') +
      (item.state ? '<span class="zs-tile__state">' + esc(item.state) + '</span>' : '') +
      '</button>';
  }

  // „Doppelflügeliges Tor Moosgrün RAL 6005“ → Titel „Doppelflügeliges Tor“, Farbe „Moosgrün RAL 6005“
  function titelOhneFarbe(titel) {
    var m = String(titel || '').match(/^(.*?)\s+((?:anthrazit|moosgrün|moosgruen|schwarz|grau)\s+RAL\s?\d{4}|feuerverzinkt|verzinkt)$/i);
    return m ? { titel: m[1], farbe: m[2] } : { titel: titel, farbe: '' };
  }

  // Farbname für Farbfelder: „Anthrazit RAL 7016“ → Anthrazit, darunter klein RAL 7016
  function swatchLabel(name) {
    var m = String(name || '').match(/^(.*?)\s+(RAL\s?\d{4})$/i);
    if (!m) return '<span class="zs-swatch__label">' + esc(name) + '</span>';
    return '<span class="zs-swatch__label">' + esc(m[1]) + '<small>' + esc(m[2]) + '</small></span>';
  }

  function farbeAusName(name) {
    var n = String(name || '').toLowerCase();
    if (/7016|anthrazit/.test(n)) return '#383e42';
    if (/6005|moosgr|grün|gruen/.test(n)) return '#2f4a3a';
    if (/9005|schwarz/.test(n)) return '#151515';
    if (/verzink|zink|silber/.test(n)) return 'linear-gradient(135deg,#d9dde1 0%,#a9b0b7 45%,#e8ebee 60%,#9aa2aa 100%)';
    return '';
  }

  function warn(text, level) {
    return '<p class="zs-warn' + (level === 'info' ? ' zs-warn--info' : '') + '">' + text + '</p>';
  }

  window.customElements.define('zs-konfigurator', ZsKonfigurator);
})();
